import { defineComponent } from "vue";
import Icon from "./component-library45.mjs";
import Datasheet from "./component-library44.mjs";
const _sfc_main = defineComponent({
  name: "EnergyLabel",
  components: { Icon, Datasheet },
  props: {
    energyClass: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    alignment: {
      type: String,
      default: "default",
      validator(value) {
        return ["default", "bottom", "justify", "left"].includes(value);
      }
    },
    noDataSheet: { type: Boolean },
    isInternalLink: { type: Boolean },
    reverse: { type: Boolean }
  },
  emits: ["click", "open-document"],
  computed: {
    alignDropdown() {
      if (["bottom", "left"].includes(this.alignment))
        return "left";
      return "right";
    },
    containerClass() {
      return {
        [`energy-label--${this.alignment}`]: true,
        "energy-label--reverse": this.reverse
      };
    }
  }
});
export {
  _sfc_main as default
};
